// Class: starling.errors.MissingContextError

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_errors_Error() {return $import(require("openfl/errors/Error"));}

// Constructor

var MissingContextError = function(message,id) {
	if(id == null) {
		id = 0;
	}
	if(message == null) {
		message = "Starling context is missing";
	}
	(openfl_errors_Error().default).call(this,message,id);
}

// Meta

MissingContextError.__name__ = ["starling","errors","MissingContextError"];
MissingContextError.__super__ = (openfl_errors_Error().default);
MissingContextError.prototype = $extend((openfl_errors_Error().default).prototype, {
	
});
MissingContextError.prototype.__class__ = MissingContextError.prototype.constructor = $hxClasses["starling.errors.MissingContextError"] = MissingContextError;

// Init



// Statics




// Export

exports.default = MissingContextError;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/errors/MissingContextError.js
// module id = 55
// module chunks = 0